import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  GDD: ["#F15C22", "#000000", "#FFFFFF"],
  MSS: ["#F4D12F", "#C80F2D", "#FFFFFF"],
  PEJ: ["#807E82", "#C1D72E", "#FFFFFF"],
  SRR: ["#008B98", "#B49A64", "#FFFFFF"],
  SCO: ["#C80F2D", "#000000ff", "#FFFFFF"],
  SUR: ["#49A942", "#BA0E2A", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};


// A pitch type is listed even when the model couldn't grade it (a game with no
// published spin data), so every stat here can legitimately be null.
const stat = (value: any, digits: number) =>
  typeof value === "number" && Number.isFinite(value) ? value.toFixed(digits) : "–";

export default function AflArsenalProfile(props: any) {
  const [pitchData, setPitchData] = useState<any[]>([]);
  useEffect(() => {
    const path = "/afl-stuff/" + props.id + "/" + (props.season ? props.season + "/" : "");
    fetch(props.prod ? "https://oriolebird.pythonanywhere.com" + path : path)
      .then((res) => res.json())
      .then((pData) => {
        //console.log("Pitch Data for ", props.id, pData);
        setPitchData(pData)
        //console.log("Pitches: ", p.toString())
      });
  }, [props.id, props.prod, props.season]);

  //console.log(props)
  const temp = Object.keys(props).includes('teamInfoProp')
  if(temp){
    props.playerInfoProp.common = {teamInfo: props.teamInfoProp}
  }

  // Get team colors for styling
  const teamColor = props.playerDataProp.afl_team !== null
    ? teamColors[props.playerDataProp.afl_team][0]
    : teamColors["FA"][0];

  const textColor = props.playerDataProp.afl_team !== null
    ? teamColors[props.playerDataProp.afl_team][1]
    : teamColors["FA"][1];

  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={2}
        marginTop={1}
      >
        <Grid maxWidth="90vw">
          <Box
            sx={{
              maxWidth: "90vw",
              width: "500px",
              border: "#293241 solid 2px",
              backgroundColor: "#FFFFFF",
              height: props.isDesktop ? "400px" : "100%",
              marginTop: "px",
              marginLeft: "0px",
              boxShadow:
                "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            }}
            justifyContent="flex-start"
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
            <div
              style={{
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                backgroundColor:
                  teamColor
              }}
            >
              {props.isDesktop &&
                (<Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography variant="h5">
                    <span
                      style={{
                        color:
                          textColor,
                        fontWeight: "bold",
                        fontSize: "25pt",
                        textAlign: "center"
                      }}
                    >
                      Arsenal Breakdown
                    </span>
                  </Typography>
                </Grid>)}
              {!props.isDesktop &&
                (<Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                ><Typography variant="h5" style={{ fontSize: "25pt" }}>
                    <div
                      style={{
                        color:
                          textColor,
                        fontWeight: "bold",
                        textAlign: "center"
                      }}
                    >
                      Arsenal Breakdown
                    </div>
                  </Typography></Grid>)}
            </div>
            <TableContainer component={Paper} style={{ margin: "10px" }}>
              <Table size="medium" padding="normal" sx={{ marginLeft: "10px", width: "120%" }}>
                <TableHead>
                  <TableRow>
                    <TableCell >Pitch Type</TableCell>
                    <TableCell >Usage</TableCell>
                    <TableCell >Velo</TableCell>
                    <TableCell >Spin</TableCell>
                    <TableCell >psStuff+</TableCell>
                    <TableCell >Arm Side</TableCell>
                    <TableCell >Vertical</TableCell>
                    <TableCell >Whiff%</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pitchData.length > 0 && pitchData.map((pitch) => <TableRow
                    key={pitch.pitch_type}
                  >
                    <TableCell ><span style={{ fontWeight: "bold" }}>{pitch.pitch_name}</span></TableCell>
                    <TableCell >{pitch.usage}%</TableCell>
                    <TableCell >{stat(pitch.velocity, 1)}</TableCell>
                    <TableCell >{stat(pitch.spin_rate, 0)}</TableCell>
                    <TableCell >{stat(pitch.psStuff, 0)}</TableCell>
                    <TableCell >{stat(-pitch.pfx_x, 2)}</TableCell>
                    <TableCell >{stat(pitch.pfx_z, 2)}</TableCell>
                    <TableCell >{stat(pitch.whiff_rate, 1)}</TableCell>
                  </TableRow>)}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}